import { render } from "./PageTitle.vue?vue&type=template&id=0ec3836a&scoped=true"
const script = {}

import "./PageTitle.vue?vue&type=style&index=0&id=0ec3836a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec3836a"]])

export default __exports__